import React from "react";
import type { ApprovalPolicyPageLoaderData } from "~/areas/library/components/ApprovalPolicies/CreateOrEditApprovalPolicyPage";
import { CreateOrEditApprovalPolicyPage } from "~/areas/library/components/ApprovalPolicies/CreateOrEditApprovalPolicyPage";
interface ApprovalPolicyPageProps {
    id: string;
    spaceId: string;
    loaderData: ApprovalPolicyPageLoaderData;
}
export function ApprovalPolicyPage({ spaceId, id, loaderData }: ApprovalPolicyPageProps) {
    return <CreateOrEditApprovalPolicyPage spaceId={spaceId} id={id} loaderData={loaderData} create={false}/>;
}
